// Origin trail: attach where-you-came-from to a navigation so detail screens can
// return you EXACTLY there (path + query), with a truthful breadcrumb label.
// Read back by <BackLink> via location.state. Falls back to the section default
// on deep-links / refresh (when there is no state).
export function fromState(location, label) {
  return { from: location.pathname + location.search, fromLabel: label };
}

// LEAVING AN EDIT OR STEP SCREEN (his rule, 29 Oct: "Edit and Done must NOT count as pages"). Done goes BACK to the
// record's own page in history — never a second copy of it on top — so Back from the record returns to his list.
// Opened straight from a link (no history in the app), Done takes the edit screen's place instead.
export function leaveStep(navigate, location, fallback) {
  if (location.state?.from || (window.history.state?.idx || 0) > 0) navigate(-1);
  else navigate(fallback, { replace: true });
}
